import React, { useEffect, useState } from 'react';
import Footer from '../Components/Footer';
import Navbar from '../Components/Navbar';
import axios from 'axios';

function Workshop() {
  const [workshops, setWorkshops] = useState([]); // State to hold the workshop data

  // Fetch workshops data on component mount
  useEffect(() => {
    const fetchWorkshops = async () => {
      try {
        const response = await axios.get('https://onexinfinity-backend.vercel.app/api/workshop');
        console.log('Workshops fetched:', response.data.data); // Debugging log for fetched data
        setWorkshops(response.data.data); // Update the state with fetched data
      } catch (error) {
        console.error('Error fetching workshops:', error);
        alert('Failed to fetch workshops. Please try again later.');
      }
    };

    fetchWorkshops();
  }, []);

  return (
    <>
      <Navbar />
      <div className='banner banner2'>
    <h2 data-aos="fade-right">Event And Workshop</h2>
  
    <p data-aos="fade-right">Home / Event And Workshop</p>
   
    </div>
    <br/>
    <br/>
    <div className='container py-5'>
      <div className='text-center mb-5' data-aos="fade-up">
        <h1 className='display-5 fw-bold mb-3'>Upcoming Events & Workshops</h1>
        <p className='lead'>Join our interactive sessions led by industry experts. Learn, network, and grow with OneXInfinity.</p>
      </div>
      
      <div className='row mb-5 g-4' data-aos="fade-up">
        <div className='col-md-4'>
          <div className='text-center p-4 h-100 bg-light rounded-3'>
            <i className='bi bi-people-fill h1 text-primary mb-3'></i>
            <h3>Expert-Led Sessions</h3>
            <p>Learn from industry leaders with years of experience in blockchain and technology.</p>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='text-center p-4 h-100 bg-light rounded-3'>
            <i className='bi bi-lightbulb h1 text-warning mb-3'></i>
            <h3>Practical Knowledge</h3>
            <p>Hands-on workshops designed to give you practical, applicable skills.</p>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='text-center p-4 h-100 bg-light rounded-3'>
            <i className='bi bi-share h1 text-success mb-3'></i>
            <h3>Networking</h3>
            <p>Connect with like-minded professionals and industry experts.</p>
          </div>
        </div>
      </div>
      
      <h2 className='text-center mb-4' data-aos="fade-up">Upcoming Events</h2>
      <div className='Workshop-cards'>

        {workshops.map((workshop) => (
          <div key={workshop._id} className='Workshop-card'>
            <div className='center'>
              <img src={workshop.image} alt={workshop.title} />
            </div>
            <div className='eventdate'>
            {new Date(workshop.date).toLocaleDateString(undefined, { day: '2-digit', month: 'short' })}
            </div>
            <div className='eventcity'>
            {workshop.location}
            </div>
            <div className='Workshop-text'>
              <h2>{workshop.title}</h2>
              <div style={{padding:'15px'}}>
              <h3 dangerouslySetInnerHTML={{ __html: workshop.description }}></h3>
            
            <div className='speaker'>
              <h5>~ {workshop.speaker}</h5>
              
            </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className='text-center mt-5' data-aos="fade-up">
        <h3>Can't find what you're looking for?</h3>
        <p className='lead mb-4'>Sign up to get notified about upcoming events and workshops</p>
        <a href='/book-call' className='btn btn-primary btn-lg'>Get Notified</a>
      </div>
    </div>
    
    <div className='bg-light py-5 mt-5'>
      <div className='container text-center'>
        <h2>Host Your Event With Us</h2>
        <p className='lead mb-4'>Interested in hosting a workshop or event? Partner with us to reach a wider audience.</p>
        <a href='/contact' className='btn btn-outline-primary btn-lg'>Contact Us</a>
      </div>
    </div>
    
    <Footer />
    </>
  );
}

export default Workshop;
